import { DOCUMENT, isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { NewsItem, NewsResponse } from '@app/core/interfaces';

/** @deprecated use NewsService from libs */
@Injectable({
    providedIn: 'root',
})
export class NewsService {
    private baseUrl: string = `${this.document.location.origin}/api/v2`;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document
    ) {}

    public getNews(amount: number = 3, productType?: string): Observable<NewsItem[]> {
        if (isPlatformServer(this.platformId)) {
            return of([]);
        }

        let uri = `${this.baseUrl}/api/nieuws-en-leuks?itemsPerPage=${amount}`;
        // We like to keep 'productType != null' in this case - this also validates undefined as true
        if (productType != null) {
            uri = `${
                this.baseUrl
            }/api/nieuws-en-leuks?itemsPerPage=${amount}&categorie=${productType.toLocaleLowerCase()}`;
        }

        return this.http
            .get(uri)
            .pipe(map((resultaat: NewsResponse) => Object.keys(resultaat.items).map((e) => resultaat.items[e])));
    }
}
